import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "opacity"
    }}>{`opacity`}</h1>
    <p><strong parentName="p">{`Since :`}</strong>{` UXP v2.0`}</p>
    <p>{`Sets the opacity of an element. The value is between 0 (transparent) and 1 (opaque).`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/opacity"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/opacity`}</a>{`  `}</p>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Photoshop 22.0.0 does `}<strong parentName="li">{`not`}</strong>{` support this property, although UXP `}<em parentName="li">{`will`}</em>{` parse it. Do `}<strong parentName="li">{`not`}</strong>{` use this style to control visibility.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      